import PropTypes from 'prop-types';

import {
  BackgroundImage, MainContainer, SummaryCard, Icon, CreatedWithZbLogo, SummaryCardContainer
} from './styled.components';

const FindYourIkigaiSummaryCard = ({
  bgColor,
  summary
}) => (
  <MainContainer bgColor={bgColor} data-testid="education-studio-summary-card">
    <SummaryCardContainer>
      <SummaryCard
        level={2}
        variant="md"
        color="wisdom40"
      >
        {`My Ikigai is ${summary}`}
        <Icon
          src="/journey to success/01 MVE Series/01 PEAKS/mve_peaks_summary2.svg"
          alt="mve_peaks_summary2"
          width={100}
        />
        <BackgroundImage
          src="/journey to success/01 MVE Series/01 PEAKS/mve_peaks_summary1.svg"
          alt="mve_peaks_summary1"
          width={500}
        />
        <CreatedWithZbLogo />
      </SummaryCard>
    </SummaryCardContainer>
  </MainContainer>
);

export default FindYourIkigaiSummaryCard;

FindYourIkigaiSummaryCard.propTypes = {
  bgColor: PropTypes.string,
  summary: PropTypes.string
};

FindYourIkigaiSummaryCard.defaultProps = {
  bgColor: null,
  summary: null
};
